import React from "react";
import MedicalContextProvider from "../../Context/MedicalContext";
import LogContextProvider from "../../Context/LoginContext";
import OrderConfirmedCreator from "./OrderConfirmedCreator";
import BasketProvider from "../../Context/BasketContext";
import UserInfoProvider from "../../Context/UserInfoContext";
import PacksProvider from '../../Context/PacksContext';
import NavBar from '../../Layouts/NavBar';
import Footer from '../../Layouts/Footer';
// import RoutesBar from "./Components/RoutesBar";
import "./OrderConfirmedCreator.css";


const OrderConfirmedRoute = () => {
  return (
    <>
        <BasketProvider>
         <UserInfoProvider>
           <LogContextProvider>
            <MedicalContextProvider>
            <PacksProvider>
            <div className="OrderPage">
                <div className="OrderPageNavBar">      
                        <NavBar/>
                     </div>
              <div className="">
                <OrderConfirmedCreator/>
              </div>
              <div className="OrderPageFooter">
                <Footer/>
              </div>
        </div>
        </PacksProvider>
             </MedicalContextProvider>
           </LogContextProvider>
          </UserInfoProvider>
        </BasketProvider>
    </>
  );
};

export default OrderConfirmedRoute;
